import React, { createContext, useMemo } from 'react';
import { MandatoryChildren } from '../../../../models/children-props';
import { DuplicateOrReschedulePostHandler } from '../PostSchedule.controller';
import { PostItemFragment } from '../../../../models/graphql';

export type PostActionType = {
  newPostAction: NewPostActionType;
  duplicatePostAction: duplicatePostActionType;
  editPostAction: EditPostActionType;
  deletePostAction: DeletePostActionType;
  showDetailsAction: ShowDetailsPostActionType;
  startDate: Date;
};

export type PostScheduleWeekProviderProps = MandatoryChildren & PostActionType;

export type NewPostActionType = (day: number, time: number, minutes: number) => void;
export type duplicatePostActionType = DuplicateOrReschedulePostHandler;
export type EditPostActionType = (postId: string) => void;
export type DeletePostActionType = (postId: string) => void;
export type ShowDetailsPostActionType = (postId: string) => void;

export const PostScheduleWeekContext = createContext<PostActionType>({
  startDate: new Date(),
  newPostAction: () => {
    // ...
  },
  duplicatePostAction: () => {
    // ...
  },
  editPostAction: () => {
    // ...
  },
  deletePostAction: () => {
    // ...
  },
  showDetailsAction: () => {
    // ...
  }
});

export const PostScheduleWeekProvider = (props: PostScheduleWeekProviderProps): JSX.Element => {
  const {
    newPostAction: newPost,
    duplicatePostAction: duplicatePost,
    editPostAction: editPost,
    deletePostAction: deletePost,
    showDetailsAction: showDetails,
    startDate
  } = props;

  const value = useMemo(
    () => ({
      startDate,
      newPostAction: (day: number, time: number, minutes: number) => {
        newPost(day, time, minutes);
      },
      duplicatePostAction: (post: PostItemFragment) => {
        duplicatePost(post, 'duplicate');
      },
      editPostAction: (postId: string) => {
        editPost(postId);
      },
      deletePostAction: (postId: string) => {
        deletePost(postId);
      },
      showDetailsAction: (postId: string) => {
        showDetails(postId);
      }
    }),
    [deletePost, duplicatePost, editPost, newPost, showDetails, startDate]
  );

  return <PostScheduleWeekContext.Provider value={value}>{props.children}</PostScheduleWeekContext.Provider>;
};
